module.exports = __webpack_public_path__ + "img/w28b.41288ef4.jpg";